/* Hover-to-play product videos (cards + product media gallery)
   Added by Claude – safe to remove. */
(function () {
  'use strict';
  if (window.__hoverVideoInit) return;
  window.__hoverVideoInit = true;
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;

  var style = document.createElement('style');
  style.textContent = [
    '.card-gallery{position:relative;}',
    '.card-gallery video.hover-preview-video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;pointer-events:none;transition:opacity .25s ease;z-index:2;border-radius:inherit;}',
    '.card-gallery video.hover-preview-video.is-active{opacity:1;}'
  ].join('');
  document.head.appendChild(style);

  /* ---------- Product cards: play product video on hover ---------- */
  var productJsonCache = {};

  function fetchFirstVideoSource(productUrl) {
    var key = productUrl.split('?')[0].split('#')[0];
    if (!productJsonCache[key]) {
      productJsonCache[key] = fetch(key + '.js', { headers: { accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !product.media) return null;
          var media = null;
          for (var i = 0; i < product.media.length; i++) {
            if (product.media[i].media_type === 'video') { media = product.media[i]; break; }
          }
          if (!media || !media.sources) return null;
          var mp4s = media.sources.filter(function (s) {
            return s.format === 'mp4' || String(s.mime_type || '').indexOf('mp4') > -1;
          });
          if (!mp4s.length) return null;
          mp4s.sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
          var pick = null;
          for (var j = 0; j < mp4s.length; j++) {
            if ((mp4s[j].height || 0) >= 480) { pick = mp4s[j]; break; }
          }
          return (pick || mp4s[mp4s.length - 1]).url;
        })
        .catch(function () { return null; });
    }
    return productJsonCache[key];
  }

  function setupCard(card) {
    if (card.__hoverVideo) return;
    card.__hoverVideo = true;
    card.addEventListener('pointerenter', function () {
      card.__hoverActive = true;
      var video = card.querySelector('video.hover-preview-video');
      if (video) {
        video.classList.add('is-active');
        video.play().catch(function () {});
        return;
      }
      if (card.__hoverVideoMissing) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      fetchFirstVideoSource(link.href).then(function (src) {
        if (!src) { card.__hoverVideoMissing = true; return; }
        var v = card.querySelector('video.hover-preview-video');
        if (!v) {
          v = document.createElement('video');
          v.className = 'hover-preview-video';
          v.muted = true;
          v.loop = true;
          v.playsInline = true;
          v.setAttribute('muted', '');
          v.setAttribute('playsinline', '');
          v.preload = 'metadata';
          v.src = src;
          card.appendChild(v);
        }
        if (card.__hoverActive) {
          v.classList.add('is-active');
          v.play().catch(function () {});
        }
      });
    });
    card.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('button, [ref*="Button"]') : null;
      if (!btn) return;
      var video = card.querySelector('video.hover-preview-video');
      if (video) {
        video.pause();
        video.classList.remove('is-active');
        card.__hoverActive = false;
      }
    }, true);
    card.addEventListener('pointerleave', function () {
      card.__hoverActive = false;
      var video = card.querySelector('video.hover-preview-video');
      if (video) {
        video.pause();
        video.classList.remove('is-active');
      }
    });
  }

  /* ---------- Product page gallery: play video on hover ---------- */
  function embedCmd(iframe, playIt) {
    try {
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: playIt ? 'playVideo' : 'pauseVideo', args: '' }), '*');
      iframe.contentWindow.postMessage(JSON.stringify({ method: playIt ? 'play' : 'pause' }), '*');
    } catch (e) {}
  }

  function revealDeferred(dm) {
    var tpl = dm.querySelector('template');
    if (!tpl) return;
    dm.appendChild(tpl.content.cloneNode(true));
    var poster = dm.querySelector('[ref="deferredMediaPlayButton"]');
    if (poster) poster.style.display = 'none';
  }

  function setupGalleryMedia(dm) {
    if (dm.__hoverVideo) return;
    dm.__hoverVideo = true;
    dm.addEventListener('pointerenter', function () {
      var video = dm.querySelector('video');
      var iframe = dm.querySelector('iframe');
      if (!video && !iframe) {
        revealDeferred(dm);
        video = dm.querySelector('video');
        iframe = dm.querySelector('iframe');
      }
      if (video) {
        video.muted = true;
        video.play().catch(function () {});
      } else if (iframe) {
        embedCmd(iframe, true);
      }
    });
    dm.addEventListener('pointerleave', function () {
      var video = dm.querySelector('video');
      if (video) video.pause();
      var iframe = dm.querySelector('iframe');
      if (iframe) embedCmd(iframe, false);
    });
  }

  function scan() {
    document.querySelectorAll('deferred-media[autoplay] video').forEach(function (v) { if (v.controls) v.controls = false; });
    document.querySelectorAll('.card-gallery').forEach(setupCard);
    document.querySelectorAll('media-gallery deferred-media').forEach(setupGalleryMedia);
  }

  scan();
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(scan, 200);
  }).observe(document.body, { childList: true, subtree: true });
})();
